<template>
  <section class="row">
    <div class="col-xs-12 col-lg-5 col-xl-4 last-lg">
      <VersionDatetimePicker
        :meta="meta"
        :item="item"
      />
      <BaseButton
        label="Ny version"
        @click="$emit('new-version')"
        v-if="showButtonNewVersion"
      />
      <BaseButton
        label="Rediger"
        @click="$emit('update')"
        v-if="showButtonUpdate"
      />

      <div class="sidebar">
        <slot name="sidebar" />
      </div>
    </div>
    <div
      class="col-xs-12 col-lg-7 col-xl-8"
      v-if="!itemExists"
    >
      <p>Der findes ingen data for denne dato. ({{ meta.selectedDate | HumanDate }})</p>
    </div>
    <div
      v-else
      class="col-xs-12 col-lg-7 col-xl-8"
    >
      <slot />
    </div>
  </section>
</template>

<script>
import BaseButton from './BaseButton.vue';
import VersionDatetimePicker from './VersionDatetimePicker.vue';
import HumanDate from '../filters/HumanDate';

export default {
    name: 'VersionPickerContainer',
    components: { VersionDatetimePicker, BaseButton },
    filters: { HumanDate },
    props: {
        meta: { type: Object, required: true },
        item: { type: Object, required: true },
        showButtonNewVersion: { type: Boolean, required: true },
        showButtonUpdate: { type: Boolean, required: true },
        itemExists: { type: Boolean, required: true },
    },
};
</script>

<style lang="scss" scoped>
.sidebar {
    margin-top: 20px;
}
</style>
